// Libraries
import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

const defaultProps = {
  width: '18.469',
  height: '15.264',
}

// Component
function IconArchiveBox({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18.469 15.264"
    >
      <g transform="translate(0 -84.449)">
        <path
          fill="#5badfa"
          d="M65.8,325.386v-9.737c-.068.006-.137.009-.2.009H49.4c-.068,0-.139,0-.2-.009v9.737a1.14,1.14,0,0,0,1.139,1.139H64.663A1.138,1.138,0,0,0,65.8,325.386ZM61.3,319.4a.569.569,0,0,1-.569.569H54.267a.569.569,0,0,1-.569-.569V317.89a.569.569,0,0,1,.569-.569h6.466a.569.569,0,0,1,.569.569V319.4Z"
          transform="translate(-48.266 -226.812)"
        />
        <path
          fill="#5badfa"
          d="M18.469,86.569v-.981a1.14,1.14,0,0,0-1.139-1.139H1.139A1.14,1.14,0,0,0,0,85.588v.981a1.139,1.139,0,0,0,.934,1.12,1.209,1.209,0,0,0,.2.019h16.19a1.209,1.209,0,0,0,.2-.019A1.139,1.139,0,0,0,18.469,86.569Z"
        />
      </g>
    </svg>
  )
}

IconArchiveBox.propTypes = propTypes

IconArchiveBox.defaultProps = defaultProps

export default IconArchiveBox
